import Cookies from 'js-cookie';
import decryptage from './decryptage';

// Check if user is logged
export default function getUserId() {
  const userIdCrypte = Cookies.get('userId');
  const userIdDecrypte = decryptage(userIdCrypte);
  return parseInt(userIdDecrypte, 10);
}
